import Config from '../../config';
import { Button } from '../button/button.component';
import { Text } from '../text/text.component';
import { Title } from '../title/title.component';

import { OhNoProps } from './oh-no.config';

const OhNo = ({ cta, text, title }: OhNoProps) => {
  return (
    <div data-testid="oh-no" className="oh-no">
      <div className="oh-no-container">
        <img className="oh-no-gif" src={`${Config.DAM_IMAGES_PATH}throwing-snowball.gif`} alt="" />
        <div className="oh-no-info-container">
          {title ? (
            <div data-testid="oh-no-title">
              <Title {...title} variantClassName="display-2" />
            </div>
          ) : null}

          {text ? (
            <div className="oh-no-text" data-testid="oh-no-text">
              <Text {...text} />
            </div>
          ) : null}

          {cta ? (
            <div
              className="snowflake-button-blue snowflake-button-primary snowflake-button-regular"
              data-testid="oh-no-cta"
            >
              <Button {...cta} />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default OhNo;
